import React, { FC } from 'react';
import ContractorLocationsList from './ContractorLocationsList';

const ContractorLocationsIndexPage: FC<any> = (): React.ReactElement => {
	return <ContractorLocationsList isMasterList />;
};

export default ContractorLocationsIndexPage;
